import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import AppActions from '../../../actions/app';

import Buttons from '@repo/ui/components/buttons';
import { Form, FormControl, FormRow, FormActions } from '@repo/ui/components/inputs/Form';
import NumericInput from '@repo/ui/components/inputs/NumericInput';
import ScalingDateSelect from '@repo/ui/components/inputs/ScalingDateSelect';
import DateScaleModal from '../../modals/DateScale';
import { Paragraph } from '@repo/ui/components/typography/Content';

export default function TimeEditor({ minDate, maxDate, allowDate, value, loading, onSubmit }) {
  const { t } = useTranslation(['vol', 'commonPlat']);
  const [mode, setMode] = useState('default');

  const handleRequestMode = useCallback(() => {
    AppActions.setModal({
      component: DateScaleModal,
      options: {
        onChangeMode: (mode, success) => {
          setMode(mode);
          success();
        },
      },
    });
  }, []);

  return (
    <Form value={value} onSubmit={onSubmit}>
      <Paragraph highlight>{t('vol:labels.alreadyLoggedDateCanEditUntilApproved')}</Paragraph>
      {allowDate && (
        <FormControl label={t('vol:labels.whenVolunteerismPerformed')}>
          <ScalingDateSelect
            id="startDate"
            required
            {...{ mode, minDate, maxDate }}
            onRequestMode={handleRequestMode}
          />
        </FormControl>
      )}
      <FormRow>
        <FormControl label={t('vol:labels.howManyHours')}>
          <NumericInput id="hours" required decimals style={{ width: 90 }} />
        </FormControl>
      </FormRow>
      <FormActions>
        <Buttons.Primary disabled={loading} type="submit">
          {t('commonPlat:actions.save')}
        </Buttons.Primary>
      </FormActions>
    </Form>
  );
}
